<template>
  <div>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.身高"
      label="身高"
      max="200"
      :option="{ suffix: '公分' }"
    ></d-input>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.體重"
      label="體重"
      max="300"
      :option="{ suffix: '公斤' }"
    ></d-input>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.腰圍"
      label="腰圍"
      max="200"
      :option="{ suffix: '公分' }"
    ></d-input>
    <d-input
      class="mt-4 text-h6"
      v-model.number="payload.體脂肪"
      label="體脂肪"
      max="100"
      :option="{ suffix: '%' }"
    ></d-input>

    <v-btn block x-large class="mt-4 text-h6" color="success" @click="submit"
      >送出</v-btn
    >
    <v-btn block x-large class="mt-8 text-h6" color="error" @click="back"
      >取消</v-btn
    >
  </div>
</template>

<script>
import station from "@/mixins/station";
export default {
  mixins: [station],
  data: () => ({
    payload: {
      身高: null,
      體重: null,
      腰圍: null,
      體脂肪: null,
    },
  }),
};
</script>

<style lang="scss" scoped>
</style>